module.exports = __webpack_public_path__ + "static/media/0312_Medium.ef683fe9.jpg";